import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ss from "../assets/images/icon/ss.png";
import monkey from "../assets/images/icon/monkey.png";
import cat from "../assets/images/icon/cat.png";
import { Modal } from "@mantine/core";
import { Button } from "@headlessui/react";

const Airdrop = () => {
  const [opened, setOpened] = useState(false);
  const [modalTitle, setModalTitle] = useState("");

  const openModal = (title) => {
    setModalTitle(title);
    setOpened(true);
  };
  const airdrops = [
    {
      logo: ss,
      name: "IOST",
      status: "Ongoing",
      statusColor: "bg-green-100 text-green-600",
      desc: "IOST",
      period: "2025-04",
      snapshotDate: "2025-03-15 00:00",
      tokenLogo: ss,
      tokenName: "IOST",
      links: ["My Airdrop", "Trade", "Learn More"],
    },
    {
      logo: cat,
      name: "MONKY",
      status: "Completed",
      statusColor: "bg-gray-100 text-gray-600",
      desc: "Wise Monkey",
      period: "2024-12",
      snapshotDate: "2024-11-29 00:00",
      tokenLogo: cat,
      tokenName: "APE",
      links: ["My Airdrop", "Learn More"],
    },
    {
      logo: monkey,
      name: "MONKY",
      status: "Completed",
      statusColor: "bg-gray-100 text-gray-600",
      desc: "Wise Monkey",
      period: "2024-12",
      snapshotDate: "2024-12-15 00:00",
      tokenLogo: monkey,
      tokenName: "FLOKI",
      links: ["My Airdrop", "Learn More"],
    },
    {
      logo: ss,
      name: "MONKY",
      status: "Pending",
      statusColor: "bg-gray-100 text-gray-600",
      desc: "Wise Monkey",
      period: "2024-12",
      snapshotDate: "2024-12-15 00:00",
      tokenLogo: ss,
      tokenName: "FLOKI",
      links: ["My Airdrop", "Learn More"],
    },
    {
      logo: monkey,
      name: "MONKY",
      status: "Completed",
      statusColor: "bg-gray-100 text-gray-600",
      desc: "Wise Monkey",
      period: "2024-12",
      snapshotDate: "2024-12-15 00:00",
      tokenLogo: monkey,
      tokenName: "FLOKI",
      links: ["My Airdrop", "Learn More"],
    },
  ];
  return (
    <>
      <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
        <Header />
        <div className="max-w-7xl mx-auto p-6">
          <h1 className="text-2xl font-bold mb-6">Tillionx Airdrops</h1>

          {/* Filter and Search */}
          <div className="lg:flex items-center justify-between mb-6">
            <select className="border rounded px-3 py-2 bg-transparent">
              <option>All</option>
              <option>Pending</option>
              <option>Ongoing</option>
              <option>Completed</option>
            </select>
            <div className="lg:flex block items-center gap-4 relative mt-4 lg:mt-0">
                <input type="text" className="py-2 px-8 border rounded-sm outline-none"/>
              <FaSearch className="text-gray-500 cursor-pointer absolute left-2 top-4" />
              <label className="flex items-center gap-2 text-sm mt-2 lg:mt-0">
                <input type="checkbox" /> Only show my airdrops
              </label>
            </div>
          </div>

          {/* Airdrop Cards */}
          <div className="space-y-4 py-4">
            {airdrops.map((item, index) => (
              <div
                key={index}
                className="border rounded-xl p-4 flex flex-col md:flex-row md:items-center justify-between"
              >
                {/* Left Section */}
                <div className="flex items-center gap-4 py-6">
                  <img src={item.logo} alt={item.name} className="w-12 h-12" />
                  <div>
                    <div className="lg:flex items-center gap-2">
                      <h2 className="font-bold">{item.name}</h2>
                      <span
                        className={`text-xs px-2 py-1 rounded ${item.statusColor}`}
                      >
                        {item.status}
                      </span>
                    </div>
                    <p className="text-sm text-gray-500">{item.desc}</p>
                  </div>
                </div>

                {/* Middle Section */}
                <div className="grid grid-cols-3 gap-8 mt-4 sm:mt-0 text-sm">
                  <div>
                    <p className="text-gray-500">Airdrop Period</p>
                    <p className="font-medium">{item.period}</p>
                  </div>
                  <div>
                    <p className="text-gray-500">Snapshot Time (UTC)</p>
                    <p className="font-medium">{item.snapshotDate}</p>
                  </div>
                  <div>
                    <p className="text-gray-500">Snapshot Token</p>
                    <div className="flex items-center gap-2">
                      <img
                        src={item.tokenLogo}
                        alt={item.tokenName}
                        className="w-5 h-5"
                      />
                      <span className="font-medium">{item.tokenName}</span>
                    </div>
                  </div>
                </div>

                {/* Right Section */}
                <div className="flex gap-4 text-yellow-700 text-sm mt-4 sm:mt-0">
                  {item.links.map((link, i) => (
                    <button
                      key={i}
                      className="hover:underline"
                      onClick={() => openModal(link)}
                    >
                      {link}
                    </button>
                  ))}
                </div>
                <Modal
                  opened={opened}
                  onClose={() => setOpened(false)}
                  title={modalTitle}
                >
                  <p className="text-gray-700">
                    No Records
                  </p>
                </Modal>
              </div>
            ))}
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Airdrop;
